import { Route } from "react-router-dom";
import { RequireAuth } from "../../services/auth";
import NFC from "./NFC";
import NFCList from "./NFCList";
import NFCPage from "./NFCPage";

export default (
  <Route
    path="NFC"
    exact
    element={
      <RequireAuth>
        <NFC />
      </RequireAuth>
    }
  >
    <Route index element={<NFCList />} />
    <Route path=":name" element={<NFCPage />} />
  </Route>
);
